import withRegistroFactura from "../../hoc/Finanzas/withRegistroFacturaOrdinaria";
import RegistroFactura from "../../view/components/Finanzas/RegistroFactura/RegistroFactura";

export default withRegistroFactura(RegistroFactura);